import _Array$isArray from '@babel/runtime-corejs3/core-js-stable/array/is-array';
import _someInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/some';

function matchesType(targetType, draggedItemType) {
  if (draggedItemType === null) {
    return targetType === null;
  }
  return _Array$isArray(targetType) ? _someInstanceProperty(targetType).call(targetType, function (t) {
    return t === draggedItemType;
  }) : targetType === draggedItemType;
}

export { matchesType };
